import { Base } from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';
import anime from 'animejs';

/**
 * Homepage class.
 */
export default class Loader extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Loader',
  };

  /**
   * Initialize the component's behavior.
   */
  mounted() {
    // Trigger animation once ready.
    this.ready = document.readyState === 'complete';
    if (this.ready) {
      this.animate();
    } else {
      window.addEventListener('load', () => {
        this.animate();
      });
    }
  }

  /**
   * Animate the loader.
   */
  animate() {
    Cookies.set('show-loader', 'false');

    anime({
      targets: this.$el,
      translateY: '-100%',
      easing: 'easeInOutQuart',
      duration: 3600,
      delay: 600,
      complete: () => {
        this.$el.style.display = 'none';
        document.body.classList.remove('with-loader');
      },
    });
  }

  /**
   * Unbind all events on destroy.
   * @returns {Loader} The Loader instance.
   */
  destroyed() {
    return this;
  }
}
